import { FullName } from "../../Checkout/FormElements/CustomerInfoForm";

type GuestNamesSummaryProps = {
  names: FullName[];
};

export default function GuestNamesSummary({ names }: GuestNamesSummaryProps) {
  if (names.length === 0) return <></>;
  if (
    names.length === 1 &&
    names[0].givenName === "" &&
    names[0].familyName === ""
  )
    return <></>;

  return (
    <div>
      <b>Customer Name{names.length === 1 ? "" : "s"}:</b>{" "}
      {names.map(({ givenName, familyName }, index) => {
        const NameEl = names.length === 1 ? "span" : "li";
        return (
          <NameEl key={index}>
            {givenName} {familyName}
          </NameEl>
        );
      })}
    </div>
  );
}
